import React from "react";
import Select from "@app/components/Select/Select";
import Additionalnformation from "@app/components/AttributeSelector/Additionalnformation";
import { useField } from "formik";

export default function DangerSelect({ ...selectProps }) {
	const { name, options } = selectProps;
	const [{ value }] = useField({ name });

	return (
		<>
			<Select {...selectProps} isSearchable />
			{/* removed because this information will be shown as options in the following selects */}
			{/*<Additionalnformation name={`${name}`} value={value} options={options} className={"mt-24"} />*/}
		</>
	);
}
